// extracted by mini-css-extract-plugin
export default {"cell":"PrivacyGrid_cell__o6F1f","cell--disabled":"PrivacyGrid_cell--disabled__bktGd","grid":"PrivacyGrid_grid__4Uj+7"};